import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LicensesService } from '../services/licenses/licenses.service';
import { DialogLicenses } from '../dialog/licenses/dialog.component.lic';
import { ListService } from '../list.service';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';
import { ILicense, ILicenseResponse } from './licenses.interfaces';

@Component({
  selector: 'mcrit-gestio-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: [ './licenses.component.css' ],
  providers: [ LicensesService, ListService ]
})
export class LicensesComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public licensesData: ILicenseResponse;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private licenseModel: ILicense = {
    'plate': '',
    'name': '',
    'number': '',
    'type': '',
    'issue_date': '',
    'expiry_date': '',
    'id_owner': ''
  };
  
  public error: string = '';
  public showDialog: boolean = false;
  public editLicensesData: ILicense;

  constructor(
    public tokenStorage: TokenStorageService, public listLicensesService: ListService, 
    public dialog: MatDialog, private licenseService: LicensesService, 
    private router: Router, private route: ActivatedRoute
  ) {
    this.userInfo = this.tokenStorage.getUser();
  }

  public exportar() { 
    this.export = true; 
    this.requestRowsToParent(); 
  }

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addLicense(): void {
    this.editLicensesData = Object.assign({}, this.licenseModel);
    let dialogFactRef = this.dialog.open(DialogLicenses, {
      disableClose: true, 
      width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh',
      data: { dades: this.editLicensesData, user: this.userInfo } 
    });
   
    dialogFactRef.afterClosed().subscribe(results => {
      if (!results) return;
      this.editLicensesData = results;
      this.addOrUpdate();
    });
  }

  public editLicense(license: ILicense): void {
    this.editLicensesData = Object.assign({}, this.licenseModel, license);
    let dialogFactRef = this.dialog.open(DialogLicenses, {
      width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh',
      data: { dades: this.editLicensesData, user: this.userInfo } 
    });

    dialogFactRef.afterClosed().subscribe(results => {
      if (!results) return;
      this.editLicensesData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    // Utilitzem el 'number' o el 'plate' com a ID natural de control per saber si és nova
    if (!this.editLicensesData.number || this.editLicensesData.number === '') {
      this.licenseService.create(this.editLicensesData)
        .subscribe(res => {
          console.log("S'ha creat l'element");
          this.router.navigate(['licenses']);
          this.requestRowsToParent();
        });
    } else {
      this.licenseService.update(<string> this.editLicensesData.number, this.editLicensesData)
        .subscribe(res => {
          console.log("S'han desat les dades");
          this.router.navigate(['licenses']);
          this.requestRowsToParent();
        });
    }
  }

  public gotoPage(page: number): void {console.log("gotoPage");
    this.listLicensesService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event) {
    if (this.currentOrdering.length == 0) ['name'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);

    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listLicensesService.currentPage * this.listLicensesService.rowsPerPage;
    this.requestRowsToParent();
  }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key] ? this.orderingParameters[key] : 0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listLicensesService.currentPage * this.listLicensesService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listLicensesService.rowsPerPage - 1, this.licensesData.registers);
  }

  private requestRowsToParent(): void {
    this.licenseService.getList(
      this.listLicensesService.rowsPerPage, 
      this.listLicensesService.currentPage * this.listLicensesService.rowsPerPage, 
      this.activeFilters,
      {},
      this.currentOrdering, 
      this.export
    ).subscribe(
      data => {
        if (!this.export) {
          this.licensesData = data;
          //this.computeDisplayedRows();
        } else {
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff", csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export_licenses.csv");
          this.export = false;
        }
      },
      error => console.log(error)
    );
  }

  public requestPrevious(): void {
     this.listLicensesService.currentPage = Math.max(0, this.listLicensesService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listLicensesService.currentPage = this.listLicensesService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
     this.listLicensesService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
  }

  public licensesFilters: Array<any>;
  public ordreCamps: Array<any>;
  public tableFields: Array<any>;

  ngOnInit() {
    this.ordreCamps = ['plate'];

    // Camps visibles a la graella de llicències
    this.tableFields = [
      ['plate', 'Plate'],
      ['number', 'Number'],
      ['name', 'Owner Name'],
      ['id_owner', 'Owner ID'],
      ['type', 'Type'],
      ['issue_date', 'Issue Date'],
      ['expiry_date', 'Expiry Date']
    ];

    // Cerca dinàmica configurable sol·licitada (plate, id_owner, number, type)
    this.licensesFilters = [
      { inputs: [] },
      {
        inputs: [
          {
            name: 'text',
            type: 'text',
            values: [
              {
                text: 'License Number',
                name: 'number',
                autocomplete: 'lic_number',
                value: this.listLicensesService.getSearchValues('text')
              },
              {
                text: 'Plate',
                name: 'plate',
                autocomplete: 'plate',
                value: this.listLicensesService.getSearchValues('text')
              },
              {
                text: 'Owner ID',
                name: 'id_owner',
                autocomplete: 'id',//owner id
                value: this.listLicensesService.getSearchValues('text')
              },
              {
                text: 'Type',
                name: 'type',
                autocomplete: 'lic_type',
                value: this.listLicensesService.getSearchValues('text')
              }
            ]
          }
        ]
      }
    ];

    this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    
    ['number'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
  
    const id = this.route.snapshot.paramMap.get('id');
 
    if (id) {
      this.computeActiveFilters({ plate: id });
    } else {
      this.computeActiveFilters({});
    }

    history.pushState(null, document.title, location.href);
    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  go(lloc, id) { 
    this.router.navigate([lloc, id]); 
  }
}